import React from 'react';
import { GalleryImage } from '../components/GalleryImage';

const GalleryPage: React.FC = () => {
  const images = [
    { src: "https://placehold.co/500x400", alt: "Students in a workshop" },
    { src: "https://placehold.co/500x600", alt: "Presenter giving a talk" },
    { src: "https://placehold.co/500x400", alt: "Community networking" },
    { src: "https://placehold.co/500x400", alt: "Team working on a project" },
    { src: "https://placehold.co/500x600", alt: "Close-up of code on a laptop" },
    { src: "https://placehold.co/500x400", alt: "Group photo of attendees" },
    { src: "https://placehold.co/500x400", alt: "Mentorship session" },
    { src: "https://placehold.co/500x400", alt: "Celebrating a hackathon win" },
    { src: "https://placehold.co/500x600", alt: "Guest speaker on stage" },
  ];

  return (
    <div className="animate-fade-in">
      <section className="py-16 text-center bg-muted">
        <div className="container mx-auto px-6">
          <h1 className="text-4xl font-bold text-foreground font-heading">Media & <span className="text-primary">Gallery</span></h1>
          <p className="text-lg text-muted-foreground mt-2">Curated visual media from our events, bootcamps, and community activities.</p>
        </div>
      </section>

      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="columns-2 md:columns-3 lg:columns-4 gap-4 space-y-4">
            {images.map((image, index) => (
              <GalleryImage key={index} src={image.src} alt={image.alt} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default GalleryPage;